import moment from 'moment';

import { restService, RestService } from 'app/api/common';

class ShoppingCartService {
    private static readonly getBasePath = (partnerId: string): string => `/v1/${partnerId}/shopping-cart`;

    private readonly restService: RestService;

    public constructor() {
        this.restService = restService;
    }

    public readonly getAppointment = (
        partnerId: string,
        billingAccountId: string,
        servicePointId: string,
    ): Promise<OrderTrackerBackend.Appointment> =>
        this.restService.get<OrderTrackerBackend.Appointment>(
            `${ShoppingCartService.getBasePath(partnerId)}/${billingAccountId}/appointment`,
            {
                params: {
                    servicePointId,
                },
            },
        );

    public readonly scheduleAppointment = (
        partnerId: string,
        billingAccountId: string,
        servicePointId: string,
        appointment: OrderTrackerBackend.Appointment,
    ): Promise<void> =>
        this.restService.post<void>(
            `${ShoppingCartService.getBasePath(partnerId)}/${billingAccountId}/appointment`,
            appointment,
            {
                params: {
                    servicePointId,
                },
            },
        );

    public readonly getAvailableAppointmentTime = (
        partnerId: string,
        billingAccountId: string,
        servicePointId: string,
        fromDate: moment.Moment,
    ): Promise<OrderTrackerBackend.DayTimeSlots[]> =>
        this.restService.get<OrderTrackerBackend.DayTimeSlots[]>(
            `${ShoppingCartService.getBasePath(partnerId)}/${billingAccountId}/appointment/available-time`,
            {
                params: {
                    fromDate: fromDate.format('YYYY-MM-DD'),
                    servicePointId,
                },
            },
        );

    public readonly getInflightOrders = (
        partnerId: string,
        billingAccountId: string,
    ): Promise<OrderTrackerBackend.Order[]> =>
        this.restService.get<OrderTrackerBackend.Order[]>(
            `${ShoppingCartService.getBasePath(partnerId)}/${billingAccountId}/inflight-orders`,
        );

    public readonly createOrderSummary = (
        partnerId: string,
        request: OrderTrackerBackend.CreateOrderSummaryRequest,
    ): Promise<OrderTrackerBackend.OrderSummary> =>
        this.restService.post<OrderTrackerBackend.OrderSummary>(
            `${ShoppingCartService.getBasePath(partnerId)}/create-order-summary`,
            request,
        );

    public readonly updateActivationDate = (
        partnerId: string,
        request: OrderTrackerBackend.UpdateActivationDateRequest,
    ): Promise<void> =>
        this.restService.patch(`${ShoppingCartService.getBasePath(partnerId)}/activation-date`, request);

    public readonly getShoppingCart = (partnerId: string, cartId: string): Promise<OrderTrackerBackend.ShoppingCart> =>
        this.restService.get<OrderTrackerBackend.ShoppingCart>(
            `${ShoppingCartService.getBasePath(partnerId)}/${cartId}`,
        );
}

const shoppingCartService = new ShoppingCartService();

export { shoppingCartService, ShoppingCartService };
